import React from 'react';
import { Icon } from '@scale/scaleui';

const WhatToExpectCards: React.FC = () => {
  return (
    <div className="flex flex-col w-fit outlier-theme scale-theme max-lg:pt-4 lg:pt-16">
      <div className="text-sm font-bold flex lg:pb-8 max-lg:pb-4">What to expect</div>
      <div className="flex items-center flex-wrap gap-y-4">
        <div className="flex flex-col bg-utility-offWhite w-32 h-32 mr-2 p-3 rounded flex-wrap gap-y-2 gap-x-2">
          <Icon icon={['far', 'clipboard-list']} variant="black" size="lg" />
          <div className="text-xs font-medium pl-2">
            Fill in your application and create account
          </div>
        </div>
        <Icon icon="arrow-right" variant="black" />
        <div className="flex flex-col bg-utility-offWhite w-32 h-32 p-3 rounded">
          <Icon icon={['far', 'id-badge']} variant="black" size="lg" />
          <div className="text-xs font-medium pl-2">Verify your identity and phone number</div>
        </div>
        <Icon icon="arrow-right" variant="black" />
        <div className="flex flex-col bg-utility-offWhite w-32 h-32 p-3 rounded">
          <Icon icon={['far', 'award']} variant="black" size="lg" />
          <div className="text-xs font-medium pl-2">Pass a skills assessment or interview</div>
        </div>
        <Icon icon="arrow-right" variant="black" />
        <div className="flex flex-col bg-utility-offWhite w-32 h-32 p-3 rounded">
          <Icon icon={['far', 'badge-check']} variant="black" size="lg" />
          <div className="text-xs font-medium pl-2">Start working and earning!</div>
        </div>
      </div>
    </div>
  );
};

export default WhatToExpectCards;
